export const translateZoningInfoNumberToString = (
  request: number | undefined,
  label?: string
): string => {
  if (request === -5555) return 'Unknown';
  if (request === -9999) return 'Not applicable';
  if (!request || request < 0) return `0${label || ''}`;

  return `${request.toString()}${label || ''}`;
};
